// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"77":"3a553a64","195":"018a6644","285":"d03dd354","560":"f9432ec6","965":"dc32bc07"}[chunkId] + ".css";
};